
export type SlabFormErrors = Record<string, string>;

export function validateSlabForm(formData: any): [boolean, SlabFormErrors] {
  const errors: SlabFormErrors = {};

  if (!formData.name?.trim()) {
    errors.name = "Nome é obrigatório";
  }

  if (!formData.type) {
    errors.type = "Tipo é obrigatório";
  }

  if (!formData.location_id) {
    errors.location = "Localização é obrigatória";
  }

  if (!formData.price_group_id) {
    errors.price_group = "Grupo de preço é obrigatório";
  }

  if (formData.price < 0) {
    errors.price = "Preço não pode ser negativo";
  }

  if (formData.quantity < 0) {
    errors.quantity = "Quantidade não pode ser negativa";
  }

  if (formData.dimensions) {
    if (formData.dimensions.length <= 0) {
      errors.length = "Comprimento deve ser maior que zero";
    }
    if (formData.dimensions.height <= 0) {
      errors.height = "Altura deve ser maior que zero";
    }
  }

  return [Object.keys(errors).length === 0, errors];
}
